import React, { FC } from 'react';
import styled from 'styled-components';
import MultiClamp from 'react-multi-clamp';

import { PlusNew } from '@crehana/icons';
import { TextLink } from '@crehana/ui';

import PriceSmall from '@crehana/ui/dist/Text/PriceSmall';

import { useProductsContainer } from '@crehana/web/dist/ReactContexts/Products';

import LazymageV2 from 'Jsx/Shared/LazyImageV2';

const Picture = styled.div`
  position: relative;
  width: 72px !important;
  height: 72px !important;
  background-color: #4b22f4;
  margin-right: 16px;
  overflow: hidden;
  flex-shrink: 0;
`;

const SmallCourseCard: FC<{
  item: {
    originalId: number;
    title: string;
    url: string;
    prices: {
      currencySymbol: string;
      price: number;
      realPrice: number;
    };
    promoImage: string;
    professor: {
      fullName: string;
    };
  };
  trackRecommendationPosition?: (
    positionSelected: number,
    originalId: number,
  ) => void;
  idx: number;
}> = ({
  item: { originalId, title, url, prices, promoImage, professor },
  trackRecommendationPosition,
  idx,
}) => {
  const { addCourseToCart, removeCourseFromCart, shoppingCartState } =
    useProductsContainer();
  const courseIsInCart =
    shoppingCartState.courseIdsInCart.indexOf(originalId) !== -1;

  return (
    <div className="pt-24 pb-24">
      <div className="relative flex items-start">
        <Picture>
          <LazymageV2
            lazyUrl={promoImage}
            imgxParams={{
              w: 72,
              h: 72,
            }}
          />
        </Picture>
        <div className="w-full">
          <div>
            <p
              onClick={() => {
                if (trackRecommendationPosition) {
                  trackRecommendationPosition(idx, originalId);
                }
                window.open(url);
              }}
              className="mb-8 cursor-pointer font-subtitle3"
            >
              <MultiClamp ellipsis="..." clamp={2}>
                {title}
              </MultiClamp>
            </p>
          </div>
          <p className="mb-8 font-legals">{professor.fullName}</p>
          <div className="flex items-center">
            <PriceSmall
              currency={prices.currencySymbol}
              price={prices.price.toLocaleString()}
              discount={
                prices.currencySymbol + prices.realPrice.toLocaleString()
              }
              discountColor="gray-dark"
            />
          </div>
          <TextLink
            label={courseIsInCart ? 'Quitar del carrito' : 'Agregar al carrito'}
            type="level2"
            leftIcon={{ component: PlusNew, size: 12, hasStroke: true }}
            className="mt-16 uppercase cursor-pointer"
            // @ts-expect-error idk
            color="secondary-main"
            onClick={() => {
              const course = {
                courseId: originalId,
              };
              const options = {
                preventRedirect: true,
              };

              if (courseIsInCart) {
                removeCourseFromCart(course, options);
              } else {
                if (trackRecommendationPosition) {
                  trackRecommendationPosition(idx, originalId);
                }
                addCourseToCart(course, options);
              }
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default SmallCourseCard;
